import React, { PropsWithChildren, useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports -- Facade internals: this file is part of the @townsquare/router wrapper around RRR. Remove with the insource (VOLTPLAT-330).
import { BrowserHistory, ResourceStoreContext } from 'react-resource-router';

import { HomepageRoutes } from '../home/types';

import { RouterShell } from './RouterShell';
import { filterAccessibleRoutes } from './filterAccessibleRoutes';
import { UserCapabilitiesData, parseUserCapabilities } from './parseUserCapabilities';

type CapabilityRouterFromVoltProps = {
	history: BrowserHistory;
	resourceContext: ResourceStoreContext;
	/** Plain-data capabilities from `globalThis.__TOWNSQUARE_BOOTSTRAP__`. */
	capabilities: UserCapabilitiesData;
	routes: HomepageRoutes;
};

/** TSQ JSON branch sibling of `CapabilityRouter`. */
export const CapabilityRouterFromVolt = (
	props: PropsWithChildren<CapabilityRouterFromVoltProps>,
) => {
	const userCapabilities = useMemo(
		() => parseUserCapabilities(props.capabilities),
		[props.capabilities],
	);
	const routes = useMemo(
		() => filterAccessibleRoutes(props.routes, props.capabilities),
		[props.routes, props.capabilities],
	);

	return (
		<RouterShell
			history={props.history}
			resourceContext={props.resourceContext}
			userCapabilities={userCapabilities}
			routes={routes}
		>
			{props.children}
		</RouterShell>
	);
};
